import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"column small-12 medium-3\">\n    <img class=\"offers-image spa-lazy-image\" data-src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"offersImage") : stack1), depth0))
    + "\" alt=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"offersImageAltText") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":100},"end":{"line":4,"column":203}}})) != null ? stack1 : "")
    + "\"/>\n  </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"offersImageAltText") : stack1), depth0)) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row full-width-row collapse\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"offersImage") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":6,"column":9}}})) != null ? stack1 : "")
    + "\n  <div class=\"column small-12\">\n    <div class=\"offers-text\">\n      <h2>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\n\n      <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"info") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n      <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"customizedOffers") : stack1)) != null ? lookupProperty(stack1,"customerText") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n\n      <p class=\"offers-link show-for-medium-up\">"
    + container.escapeExpression((lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"offersLink") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"secureHost") : stack1),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":15,"column":48},"end":{"line":15,"column":101}}}))
    + "</p>\n      <p class=\"show-for-small-only offers-link\">"
    + container.escapeExpression((lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"offersLinkMobile") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"secureHost") : stack1),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":16,"column":49},"end":{"line":16,"column":108}}}))
    + "</p>\n    </div>\n  </div>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/customized-offers-cc-module",
  "version": "1.0.1",
  "id": "customizedOffersCcModule",
  "containerID": "creditCardsCustomizedOffersCcModule",
  "moduleName": "credit-cards-customized-offers-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "customized-offers-cc-module",
  "data": {
    "init": "customizedOffersCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        secureLink
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    secureLink
  },
  "dependencies": {
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * customized-offers-cc-module
 * module_js_id: customizedOffersCcModuleJS
 *
 * Copyright (c) 2017-12-4 removed
 */

/**
 * Creates a customizedOffersCcModuleJS class.
 * @returns {Object} customizedOffersCcModuleJS class.
 */
class customizedOffersCcModuleJS extends Module {
  /**
   * @param {object} options - options object
   * @param {object} context - context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @returns {void}
   */
  init() {
    const mda = sessionStorage.getItem('mda');
    // Pass wrap=mda through default ITA offers link when in MDA
    if (mda) {
      const offersLinkMobile = document.getElementById('checkForOffersMobile');
      offersLinkMobile.href += '&wrap=mda';
      const offersLink = document.getElementById('checkForOffers');
      offersLink.href += '&wrap=mda';
    }
  }
}
registerModuleClass({
  moduleClass: customizedOffersCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { customizedOffersCcModuleJS as default, moduleConfig };
